<template>
  <div class="order">
    <div class="flex gap-5 justify-between items-end mb-6 mdmax:flex-col">
      <div class="flex w-full gap-5 mdmax:w-full mdmax:flex-col">
        <div class="w-full max-w-lg mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">{{ $t('order.search') }}</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" :placeholder="$t('order.searchPlaceholder')" v-model="keyword" @enter="doSearch()" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
        <div class="w-full max-w-xs mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">{{ $t('order.dateRange') }}</label>
          <div class="date-range relative text-xs">
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2 z-1">
              <Calendar color="neutral-700" />
            </div>
            <date-range-picker
              v-model="dateRange"
              :locale-data="{ format: 'dd/mm/yyyy', separator: ' - ' }"
              @update="setDate"
              :showDropdowns="false"
              :timePicker="false"
              :timePicker24Hour="false"
              :ranges="false"
            ></date-range-picker>
          </div>
        </div>
      </div>
      <Button :buttonText="$t('order.addOrder')" @action="createOrder" :size="isMobile ? 'full' : 'regular'" />
      <Button :buttonText="$t('order.uploadOrder')" v-if="user.is_upgraded" @action="uploadOrder" :size="isMobile ? 'full' : 'regular'" />
    </div>
    <div class="bg-white shadow-md">
      <div class="flex items-center tab shadow-border-b mdmax:overflow-x-auto">
        <div
          class="relative px-6 py-3 cursor-pointer text-center font-medium flex items-center gap-2"
          v-for="(tab, index) in tabList"
          :key="'tab-' + index"
          :class="[tab.value === selectedTab?.value ? 'active text-neutral-700' : 'text-neutral-500']"
          @click="selectTab(tab)"
        >
          <span>{{ tab.label }}</span>

          <!-- Badge -->
          <span v-if="tab.count !== undefined && tab.count > 0" class="text-xs px-2 py-0.5 rounded-full bg-red-500 text-white">
            {{ tab.count }}
          </span>
        </div>
      </div>
      <div v-if="queries.status === 'DRAFT'">
        <div class="" v-if="filteredDraftData && filteredDraftData.length > 0">
          <div v-for="order in filteredDraftData" :key="order.id">
            <DraftOrderCard :data="order" />
          </div>
        </div>
        <div class="py-10 text-center" v-else>{{ $t('order.dataNotFound') }}</div>
      </div>
      <div v-else>
        <div class="" v-if="filteredData && filteredData.length > 0">
          <div v-for="order in filteredData" :key="order.id">
            <OrderCard :data="order" />
          </div>
        </div>
        <div class="py-10 text-center" v-else>{{ $t('order.dataNotFound') }}</div>
      </div>
    </div>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile && filteredData && filteredData.length > 0">
      {{ $t('order.show') }} {{ start }} - {{ end }} {{ $t('order.from') }} {{ totalRecords }}
    </div>
    <div class="mt-8 flex justify-end items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="queries.page" :totalCount="totalRecords" :pageSize="queries.per_page" @onPageChange="onPageChange" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import dayjs from 'dayjs'
const NOW = new Date()
export default {
  components: {
    DateRangePicker,
    // CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Search: () => import(/* webpackChunkName: "Forms" */ '@/components/Icons/Search'),
    Calendar: () => import(/* webpackChunkName: "Forms" */ '@/components/Icons/Calendar'),
    OrderCard: () => import(/* webpackChunkName: "card" */ '@/components/OrderCard/OrderCard'),
    DraftOrderCard: () => import(/* webpackChunkName: "card" */ '@/components/OrderCard/DraftOrderCard'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
    // TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table')
  },
  data: () => ({
    typeList: ['Semua', 'Pickup', 'Pengiriman'],
    selectedType: '',
    awb: null,
    dateRange: {
      startDate: new Date(NOW.getFullYear(), NOW.getMonth(), NOW.getDate() - 7),
      endDate: NOW
    },
    selectedTab: '',
    searchTerm: '',
    keyword: '',
    totalRecords: 0,
    // queries.per_page: 10,
    queries: {
      page: 1,
      per_page: 10,
      search_keyword: '',
      start_date: '',
      end_date: '',
      status: 'ALL',
      sort: 'DESC'
    },
    countDraft: 0
  }),
  computed: {
    ...mapGetters('auth', ['userData']),
    ...mapGetters('order', ['orderList', 'draftOrderList']),
    ...mapGetters('common', ['isMobile']),
    filteredData() {
      let temp = this.orderList || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    filteredDraftData() {
      let temp = this.draftOrderList || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    user() {
      return this.userData?.user
    },
    start() {
      return (this.queries.page - 1) * this.queries.per_page + 1
    },
    end() {
      const lastOnPage = (this.queries.page - 1) * this.queries.per_page + this.queries.per_page
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    },
    tabList() {
      return [
        {
          label: this.$t('order.tab.all'),
          value: 'ALL'
        },
        {
          label: this.$t('order.tab.ongoing'),
          value: 'ONGOING'
        },
        {
          label: this.$t('order.tab.unpaid'),
          value: 'UNPAID'
        },
        {
          label: this.$t('order.tab.completed'),
          value: 'COMPLETED'
        },
        {
          label: this.$t('order.tab.complain'),
          value: 'COMPLAIN'
        },
        {
          label: this.$t('order.tab.draft'),
          value: 'DRAFT',
          count: this.countDraft
        }
      ]
    }
  },
  created() {
    if (Object.keys(this.$route.query).length < 1) {
      this.queries.start_date = dayjs(String(this.dateRange.startDate)).format('YYYY-MM-DD')
      this.queries.end_date = dayjs(String(this.dateRange.endDate)).format('YYYY-MM-DD')
      this.$router.push({ path: '/order', query: this.queries })
      this.selectedTab = this.tabList.filter(item => item.value === this.queries.status)[0]
    } else {
      const queries = Object.assign({}, this.$route.query)
      this.queries = queries
      this.queries.page = this.queries.search_keyword ? 1 : parseInt(queries.page)
      this.keyword = this.queries.search_keyword
      this.dateRange = {
        startDate: this.queries.start_date,
        endDate: this.queries.end_date
      }
      this.queries.per_page = parseInt(queries.per_page)
      this.selectedTab = this.tabList.filter(item => item.value === this.queries.status)[0]
      if (this.queries.status === 'DRAFT') {
        this.getDraftOrdersList(this.queries)
      } else {
        if (this.queries.search_keyword && this.queries.page !== 1) {
          this.$router.push({ path: '/order', query: this.queries })
        } else {
          this.getOrderList(this.queries)
        }
      }
    }
  },
  watch: {
    $route(val) {
      if (Object.keys(val.query).length > 0) {
        if (val.query.status === 'DRAFT') {
          this.getDraftOrdersList(this.queries)
        } else {
          this.getOrderList(this.queries)
        }
      } else {
        this.$router.push({ path: '/order', query: this.queries })
      }
    }
  },
  async mounted() {
    localStorage.removeItem('order_shipping')
    localStorage.removeItem('order_logistic')
    localStorage.removeItem('order')

    await this.countDraftOrders({}).then(res => {
      this.countDraft = res.data.data
    })
  },
  methods: {
    ...mapActions('order', ['getOrders', 'getDraftOrders', 'countDraftOrders']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    setDate(value) {
      this.queries.start_date = dayjs(String(value.startDate)).format('YYYY-MM-DD')
      this.queries.end_date = dayjs(String(value.endDate)).format('YYYY-MM-DD')
      this.$router.push({ query: this.queries })
    },
    createOrder() {
      this.showLoading()
      localStorage.removeItem('order_shipping')
      localStorage.removeItem('order_logistic')
      localStorage.removeItem('order')
      setTimeout(() => {
        this.hideLoading()
        this.$router.push('/order/step/shipping')
      }, 1000)
    },
    uploadOrder() {
      this.showLoading()
      localStorage.removeItem('order_shipping')
      localStorage.removeItem('order_logistic')
      localStorage.removeItem('order')
      setTimeout(() => {
        this.hideLoading()
        this.$router.push('/order/step/upload')
      }, 1000)
    },
    selectTab(tab) {
      this.selectedTab = tab
      this.queries.status = tab.value
      this.queries.search_keyword = ''
      this.queries.page = 1
      this.keyword = ''
      this.$router.push({ query: this.queries })
    },
    goToDetail(target) {
      this.$router.push(`/order/${target}`)
    },
    doSearch() {
      this.searchTerm = this.keyword
      this.queries.search_keyword = this.keyword
      this.queries.page = 1
      this.$router.push({ query: this.queries })
    },
    showMore(page) {
      this.page = page
      this.queries.page = page
    },
    onPageChange(page) {
      this.queries.page = page
      this.$router.push({ path: '/order', query: this.queries })
    },
    getOrderList(queries = '') {
      this.showLoading()
      this.getOrders({
        params: queries
      })
        .then(res => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch(error => {
          this.hideLoading()
          console.log('error', error.response)
        })
    },
    getDraftOrdersList(queries = '') {
      this.showLoading()
      this.getDraftOrders({
        params: queries
      })
        .then(res => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch(error => {
          this.hideLoading()
          console.log('error', error.response)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.order {
  &::v-deep .vs__search {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
  }

  &::v-deep .vdpComponent {
    font-size: 16px;
    display: block;
  }

  &::v-deep .vdpComponent input {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
  }
}

.date-range {
  &::v-deep .reportrange-text {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 2.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
  }

  &::v-deep .vue-daterange-picker {
    display: block;
  }
}

.tab {
  .active {
    &::after {
      content: '';
      display: block;
      height: 4px;
      width: 100%;
      background-color: #61d7cf;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
}
</style>
